import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import NoDataFound from "common/component/NoDataFound";
import DeleteIcon from 'common/customIcons/delete';
import { formatTimeTo12Hour } from "utilities/common";
import { Add, Margin } from "@mui/icons-material";
import { capitalizeText } from "utilities/common";

const OutOfServiceAccordion = ({
  day = "Monday",
  servicedata = [],
  //   onEdit = () => { },
  //   onDelete = () => { },
}) => {
  return (
    <Box mx={2} my={1} className="service-accordion">
      <Accordion elevation={0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            {day}
          </Typography>

        </AccordionSummary>

        <AccordionDetails sx={{ p: 0 }}>
          <TableContainer sx={{ maxHeight: 300 }}>
            <Table stickyHeader aria-label="time servicedata table">
              <TableHead sx={{ backgroundColor: "#f7f7fa" }}>
                <TableRow>
                  <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Duration
                  </TableCell>
                  <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Expected Time Spent
                  </TableCell>
                  <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Total Time Spent
                  </TableCell> <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Reason
                  </TableCell><TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Details
                  </TableCell> <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1 }}>
                    Location
                  </TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                {
                  servicedata?.length === 0 ?
                    <tr className="table-no-data-found"><td colSpan={3}><NoDataFound /></td></tr> :
                    <>
                      {servicedata?.map((service_data, index) => (
                        <TableRow key={index} hover>
                          <TableCell>
                            <Typography variant="body2">   {service_data?.duration}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {service_data?.expectedDuration}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Typography variant="body2">
                              {service_data?.actualDuration}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {service_data?.reason?.reason}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={capitalizeText(service_data?.details)} arrow placement='top'>
                              <Typography variant="body2" className='truncate line-1'>
                                {service_data?.details}
                              </Typography>
                            </Tooltip>
                          </TableCell>

                          <TableCell>
                            <Typography variant="body2">
                              {service_data?.address?.location}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                }
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default OutOfServiceAccordion;
